/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProposalDataLossViewModel } from './ProposalDataLossViewModel';
import {
    ProposalDataLossViewModelFromJSON,
    ProposalDataLossViewModelFromJSONTyped,
    ProposalDataLossViewModelToJSON,
} from './ProposalDataLossViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfProposalDataLossViewModel
 */
export interface ResultOfProposalDataLossViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfProposalDataLossViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalDataLossViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProposalDataLossViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalDataLossViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalDataLossViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfProposalDataLossViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfProposalDataLossViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ProposalDataLossViewModel}
     * @memberof ResultOfProposalDataLossViewModel
     */
    data?: ProposalDataLossViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProposalDataLossViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfProposalDataLossViewModel interface.
 */
export function instanceOfResultOfProposalDataLossViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfProposalDataLossViewModelFromJSON(json: any): ResultOfProposalDataLossViewModel {
    return ResultOfProposalDataLossViewModelFromJSONTyped(json, false);
}

export function ResultOfProposalDataLossViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfProposalDataLossViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ProposalDataLossViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfProposalDataLossViewModelToJSON(value?: ResultOfProposalDataLossViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ProposalDataLossViewModelToJSON(value.data),
        'Count': value.count,
    };
}

